<template>
  <div class="background">
    <LoginHeader></LoginHeader>
    <!-- <a href="#myModal" class="trigger-btn" data-toggle="modal">Click to Open Login Modal</a> -->
    <!--============== LOADER ================-->
    <triangle-loader v-if="showData.loader" />
    <!--================ LOADER ENDS ==============-->
    <!-- ==================== login form ================== -->
    <div class="modal-dialog modal-login" v-if="!showData.loader">
      <h2>
        <img src="./../images/phub.png" alt="Logo"> &nbsp;
        <strong>Programming Hub</strong>
      </h2>
      <br>
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Login</h4>
          <div v-if="showData.loginError" class="alert alert-danger" >{{showData.loginError }}</div>
          <!-- <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button> -->
        </div>
        <div class="modal-body">
          <form @submit.prevent="submitLogin">
            <div class="form-group">
              <i class="fa fa-user"></i>
              <input
                type="email"
                class="form-control"
                v-model="email"
                placeholder="Email"
                required="required"
              >
            </div>
            <div class="form-group">
              <i class="fa fa-lock"></i>
              <input
                type="password"
                class="form-control"
                placeholder="Password"
                required="required"
                v-model="password"
              >
            </div>
            <div class="form-group">
              <input type="submit" class="btn btn-primary btn-block btn-lg" value="Login">
            </div>
          </form>
        </div>
        <!-- <div class="modal-footer">
          <a href="#">Forgot Password?</a>
        </div>-->
      </div>
    </div>
    <!-- ==================== login form ends ================== -->
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import "vue-loaders/dist/vue-loaders.css";
import * as VueLoaders from "vue-loaders";
import LoginHeader from "./loginHeader"
Vue.use(VueLoaders);

export default {
  name: "login",
  data() {
    return {
      email: "",
      password: ""
    };
  },
  components:{
    LoginHeader
  },
  computed: {
    ...mapGetters({
      showData: "showData"
    })
  },
  methods: {
    ...mapActions(["login"]),
    submitLogin: function() {
      this.login({
        mode: this.showData.mode,
        email: this.email,
        password: this.password
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.background {
  /* padding-top: 30px; */
  /* background: url("./../images/bg.jpeg") no-repeat; */
  background-size: 100%;
  /* height: 100vh; */
}
.modal-login {
  color: #636363;
  width: 350px;
}
.modal-login .modal-content {
  padding: 20px;
  border-radius: 5px;
  border: none;
  /* opacity: 0.8; */
}
.modal-login .modal-header {
  border-bottom: none;
  position: relative;
  justify-content: center;
}
.modal-login h4 {
  text-align: center;
  font-size: 26px;
}
.modal-login .form-group {
  position: relative;
}
.modal-login i {
  position: absolute;
  left: 13px;
  top: 11px;
  font-size: 18px;
}
.modal-login .form-control {
  padding-left: 40px;
}
.modal-login .form-control:focus {
  border-color: #00ce81;
}
.modal-login .form-control,
.modal-login .btn {
  min-height: 40px;
  border-radius: 3px;
}
.modal-login .hint-text {
  text-align: center;
  padding-top: 10px;
}
.modal-login .close {
  position: absolute;
  top: -5px;
  right: -5px;
}
.modal-login .btn {
  background: #00ce81;
  border: none;
  line-height: normal;
}
.modal-login .btn:hover,
.modal-login .btn:focus {
  background: #00bf78;
}
.modal-login .modal-footer {
  background: #ecf0f1;
  border-color: #dee4e7;
  text-align: center;
  margin: 0 -20px -20px;
  border-radius: 5px;
  font-size: 13px;
  justify-content: center;
}
.modal-login .modal-footer a {
  color: #999;
}
.trigger-btn {
  display: inline-block;
  margin: 100px auto;
}
</style>
